var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
var styles = function (theme) { return ({
    root: {
        backgroundColor: theme.palette.light.background.default,
        display: 'flex',
        height: '100%',
        width: '100%',
        userSelect: 'none',
    },
    cellElement: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    headerCell: {
        display: 'flex',
        alignItems: 'center',
    },
    headerAlignLeft: {
        textAlign: 'left',
        justifyContent: 'flex-start',
    },
    headerAlignRight: {
        textAlign: 'right',
        justifyContent: 'flex-end',
    },
    headerAlignCenter: {
        textAlign: 'center',
        justifyContent: 'center',
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnDataListTableHeaderRow' });
export var DataListTableHeaderRow = function (props) {
    var columns = props.columns, cells = props.cells, onSortChange = props.onSortChange;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root }, columns.map(function (column, index) {
        var _a;
        var cellElementClassName = classNames(classes.cellElement, (_a = {},
            _a[classes.headerAlignLeft] = !!column.headerAlign || column.headerAlign === 'left',
            _a[classes.headerAlignCenter] = column.headerAlign === 'center',
            _a[classes.headerAlignRight] = column.headerAlign === 'right',
            _a));
        var _b = cells[index].props, _c = _b.children, children = _c === void 0 ? [] : _c, other = __rest(_b, ["children"]);
        return (React.createElement("div", { className: classes.headerCell, key: column.key },
            React.createElement("div", __assign({}, other), children.map(function (child, childIndex) {
                // コンテンツを保持している1にのみ処理を適用して、他の要素はそのまま描画する
                if (childIndex !== 1) {
                    return React.createElement(React.Fragment, { key: childIndex }, child);
                }
                var handleClick = column.key !== 'rowIndex' && column.key !== 'checkbox'
                    ? function () { return onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(String(column.key)); }
                    : undefined;
                return (React.createElement("div", { className: cellElementClassName, onClick: handleClick, key: childIndex }, child));
            }))));
    })));
};
